<template>
  <!-- 75rem limits the width to snugly fit up to 5 entries -->
  <section v-if="checkableOption" class="container pb-2 md:max-w-[75rem]">
    <div class="mt-4 bg-white-darker px-2 py-3 md:px-4">
      <h2 class="text-xl font-bold" v-html="category.name"></h2>
    </div>

    <div class="container mt-2 px-2 py-1 md:flex md:flex-row md:gap-3 md:px-4">
      <div class="mb-3 w-full rounded-sm md:mb-0 md:w-1/2">
        <img
          :src="checkableOption?.imageUrl ?? undefined"
          :alt="category.name"
          class="w-full"
        />
      </div>

      <div class="grow md:flex md:flex-col md:gap-5">
        <p v-html="category.description" />

        <label
          :class="{
            'ring-2 ring-green-600': checked,
            'ring-1 ring-gray-lighter': !checked,
          }"
          class="group relative mt-2 flex cursor-pointer select-none flex-wrap rounded-lg bg-gray-ultralight px-3 py-3"
        >
          <span class="flex w-full justify-between gap-2">
            <input
              :checked="checked"
              type="checkbox"
              class="size-6 cursor-pointer appearance-none rounded-md border-gray-light bg-white text-green-600 !ring-0 !ring-offset-0 checked:bg-green-600 forced-colors:appearance-auto"
              @input="
                store.toggleActiveProductOption(
                  checkableOption!,
                  category,
                  true
                )
              "
            />
            <span class="flex w-full justify-between">
              <span class="w-1/2 sm:w-full">
                {{ checkableOption?.displayName }}
              </span>
              <span
                v-if="category.productOptions?.length ?? 0 > 0"
                class="flex gap-2"
              >
                <span
                  class="text-gray-light line-through"
                  v-html="
                    category.productOptions?.[0]?.localizedRecommendedPrice
                  "
                />
                <span v-html="category.productOptions?.[0]?.localizedPrice" />
              </span>
            </span>
          </span>
        </label>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useExtraOptionsStore } from '@/stores/ExtraOptionsStore';
import {
  ProductOptionCategoryObject,
  ProductOptionCategoryProductOptionObject,
} from '@/types/joostconnector';
import { computed, PropType } from 'vue';

const store = useExtraOptionsStore();

const props = defineProps({
  category: {
    type: Object as PropType<ProductOptionCategoryObject>,
    required: true,
  },
});

const checkableOption: ProductOptionCategoryProductOptionObject | null =
  props.category.productOptions?.[0] ?? null;
const checked = computed(
  () => store.selectedOptions[props.category.id]?.id === checkableOption?.id
);
</script>
